export default {
  title: 'Suositellut tuotteet',
};
